import Icon, { IconNames } from "components/Icon/Icon";

type Props = {
  iconName: IconNames;
};

function IconComponent({ iconName }: Props) {
  return <Icon className="w-5 h-5" name={iconName} />;
}

export default IconComponent;
